<template>
  <div class="footer-block">
    <div class="thin-gabarit">
      <div class="entry-container">
        <div v-for="entry in data.entries" :key="entry.value + entry.description" class="entry">
          <span class="main-data">{{ entry.value }}</span>
          <span class="description">{{ entry.description }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.footer-block {
  background-color: colors.$light-stone-color;
}
.entry-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2.875em;
  padding-bottom: 2.875em;
  .entry {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 2em;
    padding-right: 2em;
    box-sizing: border-box;
    flex: 1;
    .main-data {
      font-size: 5.375em;
      line-height: 1em;
      font-family: 'Golden Plains';
    }
    .description {
      font-size: 1.75em;
      text-align: center;
    }
  }
}
</style>
